export enum InnerComponentBlock {
  Root = 'InnerComponent',
}

export enum InnerComponentElement {
  Content = 'content',
}
